import encryptServer from '@/request/encryptRequest.js';

// 商品分类-一级分类列表
export const levelOneCategoryList = () => encryptServer.post('/xiaozi-xms/wireless/saas/goods/merchant/category/levelOneCategoryList', {});

// 商品分类-新增
export const addCategory = data => encryptServer.post('/xiaozi-xms/wireless/saas/goods/merchant/category/add', data);

// 商品分类-修改
export const upDateCategory = data => encryptServer.post('/xiaozi-xms/wireless/saas/goods/merchant/category/update', data);

// 商品分类-删除
export const deleteCategory = data => encryptServer.post('/xiaozi-xms/wireless/saas/goods/merchant/category/delete', data);

// 商品分类-分类详情
export const categoryDetail = data => encryptServer.post('/xiaozi-xms/wireless/saas/goods/merchant/category/detail', data);

// 商品分类-根据上级查询下级分类列表
export const getListByPid = data => encryptServer.post('/xiaozi-xms/wireless/saas/goods/merchant/category/getListByPid', data);

// 商品分类-查询分类树
export const getCategoryLists = data => encryptServer.post('/xiaozi-xms/wireless/saas/goods/merchant/category/tree', data);

// 平台分类-根据分类编码查询分类树
export const treeByCodes = data => encryptServer.post('/xiaozi-xms/wireless/saas/goods/category/treeByCodes', data);

// 分类树
export const tree = data => encryptServer.post('/xiaozi-xms/wireless/saas/goods/category/tree', data);

// 分类树 (1xie)
export const tree1xie = data => encryptServer.post('/xiaozi-xms/wireless/saas/1xie/category/tree', data);

// 平台分类-根据分类编码查询分类树 (1xie)
export const treeByCodes1xie = data => encryptServer.post('/xiaozi-xms/wireless/saas/1xie/category/treeByCodes', data);

// 企业库接口
export const enterpriseList = data => encryptServer.post('/xiaozi-xmo/wireless/saas/enterprise/pageList', data);
